<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 17/7/2023
  -->

<template>
<div class="gatherFeedbackViewRoot">

	<qw-button
		type="primary"
		class="hide-on-print font-size-4"
		style="padding: 8px 50px; width: 185px;"
		@click="showFeedback">Get Help</qw-button>
<!--	<div class="report-button">-->
<!--		hey-->
<!--	</div>-->
</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
let FeedbackDialog = () => import("@/tools/FeedbackGather/FeedbackDialog.vue");
import {createDialogLazy} from "@/utils/helpers-external";

let feedbackDialog = createDialogLazy(FeedbackDialog)

export default {
	name: "GatherFeedbackView",
	components: {FeedbackDialog},
	extends: BaseComponent,


	methods: {
		async showFeedback() {
			await this.emitPromise("feedbackClicked")
			await feedbackDialog()
		},
	},
}
</script>

<style lang="scss">

.gatherFeedbackViewRoot{
	position: fixed;
	bottom: 10px;
	left: 10px;

	.report-button{
		width: 100px;
		height: 50px;
		background: #00aced;
		border-radius: 50%;

		&:hover{
			background: darken(#00aced, 10%);
		}

	}
}

</style>
